import Axios from 'axios';
import jsCookie from 'js-cookie';

export interface Session {
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  id_token: string;
  accountID: string;
  accountType: string;
  imageURL?: string;
  accessToken: string;
  user: User;
}
interface User {
  __v: number;
  _id: string;
  createdAt: string;
  email: string;
  updatedAt: string;
  firstname: string;
  fullname: string;
  lastname: string;
  userid: number;
  userpictureurl: string;
  admin: boolean;
}

export interface LoginWithGoogleOptions {
  role: 'student' | 'teacher'
}

class Auth {
  // checks if there's an available cookie to consume that came from login endpoint
  // if available, it will transfer the data to session storage via setSession
  static syncCookie() {
    try {
      const data = jsCookie.get('User');
      if (typeof data !== 'string' || !data) return;

      const user = JSON.parse(atob(data)) as any;
      if (typeof user !== 'object') return;

      // Auth.setSession({
      //   name: user.Name,
      //   firstName: user.Given_name,
      //   lastName: user.Family_name,
      //   email: user.Email,
      //   accountID: user.Id,
      //   id_token: user.Id_token,
      //   accountType: user.Role,
      //   imageURL: user.Picture,
      // });
    } catch (e) {
      console.error(e);
    }
  }

  // sets session data to local storage
  static setSession(data: Session | null) {
    localStorage.setItem('APP_USER_SESSION', JSON.stringify(data));
  }

  // retrieves session data from local storage
  static getSession(): Session | null {
    try {
      Auth.syncCookie();
      return JSON.parse(String(localStorage.getItem('APP_USER_SESSION')));
    } catch {
      return null;
    }
  }

  // checks if current session is an admin
  static isAdmin(): boolean {
    return Auth.getSession()?.user.admin === true;
  }

  // checks if current session is a student
  static isStudent(): boolean {
    return Auth.getSession()?.user.admin === false;
  }

  // logout; removes session data from local storage
  static logout() {
    Auth.setSession(null);
    jsCookie.remove('User');
  }

  // login with google
  static async loginWithGoogle(options: LoginWithGoogleOptions): Promise<Session | null> {
    const { data } = await Axios.get('/grant-scopes', {
      params: { login_page_role: options.role }
    });
    window.location.href = data;
    return Auth.getSession();
  }

  static async login({ email, password, role }:{ email:string, password:string, role?: 'student' | 'admin' }) {
    const res = await Axios.post('/login', { email, password, strategy: 'local' });
    
    if(role === 'admin' && !res?.data?.authentication?.payload?.moodle_user?.admin) return null;
    
    if(res) {
        const session = {
          accessToken: res.data.accessToken,
          user: {
            ...res.data.user,
            ...res.data.authentication.payload.moodle_user,
          },
        };
        localStorage.setItem('APP_USER_SESSION', JSON.stringify(session));
    }

    return res;
  }
}

export default Auth;